const SAME_PAGE_FALLBACK_TARGETS: Array<{ pathSuffix: string; targetId: string }> = [
    { pathSuffix: '/pcsoft', targetId: 'mission' },
    { pathSuffix: '/pcsoft.htm', targetId: 'mission' },
];

const inferFallbackTarget = (pathname: string): HTMLElement | null => {
    for (const { pathSuffix, targetId } of SAME_PAGE_FALLBACK_TARGETS) {
        if (pathname.endsWith(pathSuffix)) {
            const el = document.getElementById(targetId);
            if (el) return el;
        }
    }
    return null;
};

export const initNavSamePageScroll = (): void => {
    const navs = document.querySelectorAll<HTMLElement>('#main-menu, #mobile-menu');
    if (!navs.length) return;

    navs.forEach((nav) => {
        nav.addEventListener('click', (event) => {
            const target = event.target as HTMLElement | null;
            const link = target?.closest<HTMLAnchorElement>('a[href]');
            if (!link) return;

            let linkUrl: URL;
            try {
                linkUrl = new URL(link.href);
            } catch {
                return;
            }

            if (linkUrl.origin !== window.location.origin) return;
            if (linkUrl.pathname !== window.location.pathname) return;

            if (linkUrl.hash) {
                const id = linkUrl.hash.slice(1);
                const el = document.getElementById(id);
                if (!el) return;
                event.preventDefault();
                el.scrollIntoView({ behavior: 'smooth' });
                history.replaceState(null, '', linkUrl.href);
                return;
            }

            const fallbackEl = inferFallbackTarget(linkUrl.pathname);
            if (fallbackEl) {
                event.preventDefault();
                fallbackEl.scrollIntoView({ behavior: 'smooth' });
                history.replaceState(null, '', linkUrl.href);
                return;
            }

            event.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            history.replaceState(null, '', linkUrl.href);
        });
    });
};
